module.exports = __webpack_public_path__ + "static/img/3.77d04cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/sp/3.png
// module id = +Yeu
// module chunks = 0